import { httpsCallable } from 'firebase/functions';
import { getFirebaseFunctions } from './firebase';

export type PushMenuToCustomerAppResult = {
  synced: number;
  deleted: number;
};

/** Ask POS Functions to copy the current menu into the customer app. */
export async function pushMenuToCustomerApp(): Promise<PushMenuToCustomerAppResult> {
  const call = httpsCallable<Record<string, never>, { synced?: number; deleted?: number }>(
    getFirebaseFunctions(),
    'pushMenuToCustomerApp',
    { timeout: 300_000 },
  );
  try {
    const result = await call({});
    return {
      synced: Number(result.data?.synced) || 0,
      deleted: Number(result.data?.deleted) || 0,
    };
  } catch (err) {
    throw new Error(readableMenuSyncError(err));
  }
}

function readableMenuSyncError(err: unknown): string {
  const codeRaw = err && typeof err === 'object' && 'code' in err ? String((err as { code: unknown }).code) : '';
  const code = codeRaw.replace(/^functions\//, '');
  const message = err instanceof Error ? err.message.replace(/^Firebase:\s*/i, '').trim() : '';
  const bareCode = !message || message === code || message === 'internal' || message === 'not-found';
  if (code === 'not-found' || (bareCode && code === 'internal')) {
    return 'Could not update the customer app. Deploy the menu sync functions, then try again.';
  }
  if (code === 'unauthenticated' || code === 'permission-denied') {
    return 'Sign in as staff to update the customer app.';
  }
  if (code === 'failed-precondition' && message) return message;
  if (!bareCode && message) return message;
  return 'Could not update the customer app. Try again in a moment.';
}
